<!--
 * @Description: 异动反馈情况
 * @Author: cxh
 * @Date: 2023-05-16 17:14:17
 * @LastEditTime: 2023-05-19 14:09:20
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" @fetch="fetch" tableId="fbuClientsFollowChangeFeedback">
    <template #bodyCell="{ column, text }">
      <template v-if="column.dataIndex === 'process'">
        <EditorTableText :value="text" />
      </template>
    </template>
  </cos-table>
</template>
<script lang="ts">
import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/gucangSales/analysis'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { listByParamCodes } from '@/api/common'
import { alarmTypeEnum, alarmLevelEnum, alarmProcessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
export default { name: 'DcCosFbuFollowChangeFeedback' }
</script>
<script setup lang="ts">
const paramCodeData = ref<any>({
  fbu_change_description: [] // 异动说明
})
const props = defineProps({
  cosId: {
    type: String,
    require: true
  }
})
const columns = computed(() => [
  {
    title: '异动触发时间',
    dataIndex: 'alarmDate'
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '异动类型',
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: '异动级别',
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: '异动原因',
    dataIndex: 'alarmInfo'
  },
  {
    title: '异动说明',
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.fbu_change_description
  },
  {
    title: '具体详情',
    dataIndex: 'process'
  },
  {
    title: '反馈时间',
    dataIndex: 'processTime'
  },
  {
    title: '反馈情况',
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  if (!props.cosId) {
    callBack({
      items: [],
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0
    })
    return
  }
  followAlarmGet({
    ...params,
    cosId: props.cosId
  }).then((res) => {
    callBack(res)
  })
}
</script>
